import React from 'react'
import MaterialTable from 'material-table'
import {
  Card,
  Grid,
  Select,
  Checkbox,
  MenuItem,
  InputLabel,
  Typography,
  CardContent,
  FormControl,
  FormControlLabel,
} from '@material-ui/core'
import CardTitle from '../../../components/sharedComponents/CardTitle'
import { useStyles } from './styles'

const Metros2Page = (props) => {
  const {
    onChangeFilter,
    handleUpdatem2,
    destinataries,
    handleChange,
    lookup,
    channels,
    filters,
  } = props
  const classes = useStyles()
  const labels = [
    { label: 'Inactivo', color: '#f44336' },
    { label: 'Activo', color: '#4caf50' },
    { label: 'Nuevo', color: '#FAA500' },
  ]

  const columns = [
    {
      title: 'Estado',
      field: 'ESTADO',
      editable: 'never',
      render: (rowData) => (
        <FormControlLabel
          label={labels[Number(rowData.ESTADO)].label}
          control={
            <Checkbox
              indeterminate={rowData.ESTADO === '2'}
              onChange={(event) => handleChange(event, rowData)}
              checked={rowData.ESTADO === '1'}
              style={{ color: labels[Number(rowData.ESTADO)].color }}
            />
          }
        />
      ),
    },
    {
      title: 'Cliente Destinatario',
      field: 'Cliente_Destinatario',
      editable: 'never',
    },
    {
      title: 'Nombre Cliente Destinatario',
      field: 'Nombre_Cliente_Destinatario',
      editable: 'never',
    },
    {
      title: 'Canal',
      field: 'CANAL',
      lookup
    },
    {
      title: 'Gerente',
      field: 'GERENTE',
      editable: 'never'
    },
    {
      title: 'Jefe comercial',
      field: 'JEFE',
      editable:'never'
    },
    {
      title: 'Metros2',
      field: 'metros2',
      type: 'never'
    },
  ]

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <CardTitle title="Metros 2 y Canal" />
          <Card className={classes.card}>
            <CardContent>
              <Typography className={classes.title}>Filtros</Typography>
              <FormControl className={classes.formControl}>
                <InputLabel>Canal</InputLabel>
                <Select
                  value={filters.CANAL || ''}
                  onChange={(event) =>
                    onChangeFilter(event.target.value, 'CANAL')
                  }
                >
                  <MenuItem value={null}>Todos</MenuItem>
                  {channels?.map((channel) => (
                    <MenuItem key={channel.id} value={channel.canal}>
                      {channel.canal}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl className={classes.formControl}>
                <InputLabel>Estado</InputLabel>
                <Select
                  value={filters.ESTADO || ''}
                  onChange={(event) =>
                    onChangeFilter(event.target.value, 'ESTADO')
                  }
                >
                  <MenuItem value={null}>Todos</MenuItem>
                  <MenuItem value="0">Inactivo</MenuItem>
                  <MenuItem value="1">Activo</MenuItem>
                  <MenuItem value="2">Nuevo</MenuItem>
                </Select>
              </FormControl>
            </CardContent>
          </Card>
          <MaterialTable
            style={{ color: 'ff9800' }}
            title="Solicitudes"
            columns={columns}
            data={destinataries}
            editable={{
              isEditable: (rowData) => rowData.ESTADO === '1',
              onRowUpdate: (newData) =>
                new Promise((resolve) => {
                  handleUpdatem2({
                    newData,
                  })
                  setTimeout(() => {
                    resolve()
                  }, 4000)
                }),
            }}
            options={{
              headerStyle: {
                backgroundColor: '#FAA500',
                color: '#FFF',
              },
              actionsColumnIndex: -1,
            }}
          />
        </Grid>
      </Grid>
    </>
  )
}

export default Metros2Page
